module.exports = Promise.all([__parcel__import__("hzxtt"), __parcel__import__("8oEAA")]).then(() => parcelRequire('3pHq1'));